
import { defineComponent } from 'vue';
import useDarkMode from '@/composables/useDarkMode';

export default defineComponent({
  name: 'AppIconLogo',

  setup() {
    const { darkMode } = useDarkMode();

    return {
      darkMode
    };
  }
});
